"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Read-only result of the impact value.
 */


var RealImpactValue =
/*#__PURE__*/
function () {
  function RealImpactValue(salesVolumeImpact, // sales volume (quantity) impact for amount units
  bm, // real margin (BM2) in CZK for amount units (LOG-4813)
  bmPercent, // real margin (BM2) in % for amount units
  bmImpact, // margin impact in CZK for amount units
  bmImpactInPercent, // margin impact in %
  profit, // real profit (BM1) in CZK for amount units (LOG-4813)
  profitPercent, // real profit (BM1) in % for amount units
  profitImpact, // profit impact in CZK for amount units
  profitImpactInPercent, // profit impact in %
  revenueImpact, // revenue impact in CZK for amount units
  estimationInPercent, // estimation in %
  // debug values, to be removed (excluding the columns shown in frontend)
  forecast, forecastObsolete, // if true, forecast sum does not cover the entire period due to its expiration
  expectedRevenue, amount, // real quantity (ks, kg, ...), newly also shown in FE (LOG-4813)
  saleValueWithVat, // real sales (revenue) in CZK, newly also shown in FE (LOG-4813)
  saleValueWithoutVat, // real sales (revenue) in CZK without VAT, newly also shown in FE (LOG-5715)
  costValue, diffDays) {
    _classCallCheck(this, RealImpactValue);

    this.salesVolumeImpact = salesVolumeImpact;
    this.bm = bm;
    this.bmPercent = bmPercent;
    this.bmImpact = bmImpact;
    this.bmImpactInPercent = bmImpactInPercent;
    this.profit = profit;
    this.profitPercent = profitPercent;
    this.profitImpact = profitImpact;
    this.profitImpactInPercent = profitImpactInPercent;
    this.revenueImpact = revenueImpact;
    this.estimationInPercent = estimationInPercent;
    this.forecast = forecast;
    this.forecastObsolete = forecastObsolete;
    this.expectedRevenue = expectedRevenue;
    this.amount = amount;
    this.saleValueWithVat = saleValueWithVat;
    this.saleValueWithoutVat = saleValueWithoutVat;
    this.costValue = costValue;
    this.diffDays = diffDays;
  }

  _createClass(RealImpactValue, [{
    key: "getValue",
    value: function getValue() {
      return this;
    }
  }, {
    key: "add",
    value: function add(impact) {
      throw new Error('Method not supported.');
    }
  }, {
    key: "addInGroup",
    value: function addInGroup(impact) {
      throw new Error('Method not supported.');
    }
  }], [{
    key: "of",
    value: function of(impact) {
      return impact ? impact.getValue() : null;
    }
  }]);

  return RealImpactValue;
}();

exports.RealImpactValue = RealImpactValue;

RealImpactValue.ctor = function (mat) {
  return new RealImpactValue(mat.salesVolume, mat.bm, mat.bmPercent, mat.bmImpact, mat.bmImpactInPercent, mat.profit, mat.profitPercent, mat.profitImpact, mat.profitImpactInPercent, mat.revenueImpact, mat.estimationInPercent, mat.forecast, mat.forecastObsolete, mat.expectedRevenue, mat.amount, mat.saleValueWithVat, mat.saleValueWithoutVat, mat.costValue, mat.diffDays);
};

RealImpactValue.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RealImpactValue.name);
  return {
    salesVolumeImpact: builder.bigNum('salesVolumeImpact'),
    bm: builder.bigNum('bm'),
    bmPercent: builder.bigNum('bmPercent'),
    bmImpact: builder.bigNum('bmImpact'),
    bmImpactInPercent: builder.bigNum('bmImpactInPercent'),
    profit: builder.bigNum('profit'),
    profitPercent: builder.bigNum('profitPercent'),
    profitImpact: builder.bigNum('profitImpact'),
    profitImpactInPercent: builder.bigNum('profitImpactInPercent'),
    revenueImpact: builder.bigNum('revenueImpact'),
    estimationInPercent: builder.bigNum('estimationInPercent'),
    forecast: builder.bigNum('forecast'),
    forecastObsolete: builder.bool('forecastObsolete'),
    expectedRevenue: builder.bigNum('expectedRevenue'),
    amount: builder.bigNum('amount'),
    saleValueWithVat: builder.bigNum('saleValueWithVat'),
    saleValueWithoutVat: builder.bigNum('saleValueWithoutVat'),
    costValue: builder.bigNum('costValue'),
    diffDays: builder.num('diffDays')
  };
}();